class TextUtils {
	static slugify(str) {
		str = str.replace(/^\s+|\s+$/g, ''); // trim
		str = str.toLowerCase();

		// remove accents, swap ñ for n, etc
		var from = "àáãäâąèéëêęìíïîóòóöôùúüûñńśçćźżł·/_,:;";
		var to   = "aaaaaaeeeeeiiiiooooouuuunnscczzl------";

		for (var i=0, l=from.length ; i<l ; i++) {
			str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
		}

		str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
			.replace(/\s+/g, '-') // collapse whitespace and replace by -
			.replace(/-+/g, '-'); // collapse dashes

		return str;
	}

	static countOccurrences(needle, haystack) {
		if (!haystack || !needle) {
			return 0;
		}

		haystack = haystack.toLocaleLowerCase().replaceAll(/[:;,.!?—]/g, ' ');
		haystack = haystack.replaceAll('<', ' <').replaceAll('>', '> ');
		needle = needle.toLocaleLowerCase();
		let keywordLength = this.countWords(needle);

		let count = 0;
		if (keywordLength > 1) {
			var regExp = new RegExp(needle, "gi");
			count = (haystack.match(regExp) || []).length;
		} else {
			let words = haystack.split(' ');
			words = words.filter((word) => word.trim());
			let occurrences = words.filter((word) => word === needle);
			count = occurrences.length;
		}
		return count;
	}

	static countSyllables(text) {
		if (text === '') {
			return 0;
		}
		if (text.length <= 3) {
			return 1;
		}
		text = text.toLowerCase();
		text = text.replace(/(?:[^laeiouy]es|ed|[^laeiouy]e)$/, '');
		text = text.replace(/^y/, '');
		var syllables = text.match(/[aeiouy]{1,2}/g);
		return syllables ? syllables.length : 0;
	}

	static countWords(text) {
		if (!text) {
			return 0;
		}
		text = text.replace(/(\r\n|\n|\r)/gm, ' ');
		text = text.replace(/[\u2000-\u206F\u2E00-\u2E7F\\!"#$%&()*+,\-.\/:;<=>?@\[\]^_`{|}~]/g, ' ');

		var words = text.split(' ');
		words = words.map(word => {
			return word.trim();
		});
		words = words.filter(word => {
			return word && word !== '' && word !== '\n';
		});
		return words.length || 0;
	}

	static isPhraseInText(phrase, text) {
		if (!phrase || !text) {
			return false;
		}
		phrase = phrase.toLowerCase();
		text = text.toLowerCase();
		let textNoPunc = text.replace(/[:;,.!?-]/g, '');

		return text.includes(phrase) || textNoPunc.includes(phrase);
	}
}

export default TextUtils;